import { useFeatures, WorkspaceFeatures } from "@expert/features";
import { useEffect } from "react";

import { useIVRInfo } from "@/customer-info/api";
import { useLogger } from "@/sdk/logging";

export const useDynamicCallbackIntent = (type: "callbar" | "summary") => {
    const logger = useLogger({ module: "useDynamicCallbackIntent" });
    const {
        features: { dynamicCallbackCallbarEnabled, dynamicCallbackSessionSummaryEnabled },
    } = useFeatures<WorkspaceFeatures>();
    const { intent } = useIVRInfo();
    const isDynamicCallbackIntent =
        intent?.toLowerCase() === "insurance and claims" || intent?.toLowerCase() === "carrier account management";
    const featureIsEnabled = type === "callbar" ? dynamicCallbackCallbarEnabled : dynamicCallbackSessionSummaryEnabled;
    const isDynamicCallbackActive = isDynamicCallbackIntent && featureIsEnabled;

    const disabledTooltip = isDynamicCallbackActive
        ? `Callbacks are not supported for ${intent?.toLowerCase()} calls`
        : undefined;

    useEffect(() => {
        logger.info(
            {
                isDynamicCallbackIntent,
                isDynamicCallbackActive,
                featureIsEnabled,
                disabledTooltip,
                dynamicCallbackCallbarEnabled,
                dynamicCallbackSessionSummaryEnabled,
            },
            `Dynamic callback ${type}: isDynamicCallbackActive=${String(isDynamicCallbackActive)}, featureEnabled=${String(featureIsEnabled)}, intent='${intent ?? "none"}'`,
        );
    }, [
        isDynamicCallbackIntent,
        isDynamicCallbackActive,
        featureIsEnabled,
        disabledTooltip,
        dynamicCallbackCallbarEnabled,
        dynamicCallbackSessionSummaryEnabled,
        intent,
        type,
        logger,
    ]);

    return {
        isDynamicCallbackActive,
        disabledTooltip,
    };
};
